/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import type {ComponentPropsWithRef, ReactElement} from 'react'

/**
 * @public
 */
export function DoubleQuoteIcon(props: ComponentPropsWithRef<'svg'>): ReactElement {
  return (
    <svg
      data-sanity-icon="double-quote"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1764 6.22451C10.4867 6.10865 10.8319 6.26581 10.9479 6.57608C11.0636 6.88624 10.9064 7.23147 10.5964 7.34756C8.53413 8.35198 7.12778 11.0397 6.93117 13.3707C6.91621 13.5481 7.13247 13.6467 7.27806 13.5443C7.76531 13.2016 8.35885 13.0001 8.99968 12.9999C10.6562 13.0001 11.9994 14.3434 11.9997 15.9999C11.9995 17.6564 10.6562 18.9997 8.99968 18.9999C7.14062 18.9999 6.13458 18.2823 5.51726 17.0995C4.9297 15.9733 4.88735 14.5231 5.16863 13.1073C5.45257 11.6784 6.08038 10.2025 6.93523 8.96865C7.78582 7.74103 8.89804 6.70267 10.1764 6.22451Z"
        fill="currentColor"
      />
      <path
        d="M18.1767 6.22451C18.487 6.10865 18.8322 6.26581 18.9482 6.57608C19.0639 6.88624 18.9067 7.23147 18.5967 7.34756C16.5344 8.35198 15.1281 11.0397 14.9315 13.3707C14.9165 13.5481 15.1328 13.6467 15.2784 13.5443C15.7656 13.2016 16.3592 13.0001 17 12.9999C18.6565 13.0001 19.9998 14.3434 20 15.9999C19.9998 17.6564 18.6565 18.9997 17 18.9999C15.1409 18.9999 14.1349 18.2823 13.5176 17.0995C12.93 15.9733 12.8877 14.5231 13.1689 13.1073C13.4529 11.6784 14.0807 10.2025 14.9355 8.96865C15.7861 7.74103 16.8983 6.70267 18.1767 6.22451Z"
        fill="currentColor"
      />
    </svg>
  )
}

export {DoubleQuoteIcon as default}
